import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import * as Types from '../../../../types/api.types.generated.d';

const defaultOptions = {} as const;
export type SignRealtimerAccessTokenMutationVariables = Types.Exact<{ [key: string]: never }>;

export type SignRealtimerAccessTokenMutation = {
  __typename?: 'Mutation';
  signRealtimerAccessToken: string;
};

export const SignRealtimerAccessTokenDocument = gql`
  mutation signRealtimerAccessToken {
    signRealtimerAccessToken
  }
`;
export type SignRealtimerAccessTokenMutationFn = Apollo.MutationFunction<
  SignRealtimerAccessTokenMutation,
  SignRealtimerAccessTokenMutationVariables
>;

/**
 * __useSignRealtimerAccessTokenMutation__
 *
 * To run a mutation, you first call `useSignRealtimerAccessTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignRealtimerAccessTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signRealtimerAccessTokenMutation, { data, loading, error }] = useSignRealtimerAccessTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignRealtimerAccessTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SignRealtimerAccessTokenMutation,
    SignRealtimerAccessTokenMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SignRealtimerAccessTokenMutation,
    SignRealtimerAccessTokenMutationVariables
  >(SignRealtimerAccessTokenDocument, options);
}
export type SignRealtimerAccessTokenMutationHookResult = ReturnType<
  typeof useSignRealtimerAccessTokenMutation
>;
export type SignRealtimerAccessTokenMutationResult =
  Apollo.MutationResult<SignRealtimerAccessTokenMutation>;
export type SignRealtimerAccessTokenMutationOptions = Apollo.BaseMutationOptions<
  SignRealtimerAccessTokenMutation,
  SignRealtimerAccessTokenMutationVariables
>;
